import React from "react";
import cx from "classnames";
import * as styles from "./Mw3dsFrame.module.scss";
import { useSelector } from "hooks";

export const MW_3DS_FRAME_ID = "mw3dsFrame";

export const Mw3dsFrame = () => {
  const showIframe = useSelector((state) => state.sections.wallet.isManual3ds);

  return (
    <div
      className={cx(styles.mw3dsFrame, {
        [styles.visible]: showIframe,
      })}
    >
      <iframe id={MW_3DS_FRAME_ID} name={MW_3DS_FRAME_ID} />
    </div>
  );
};
